
import React, { 
    useEffect,
    useState,
} from "react"

import { 
    Dropdown,
    DropdownItem,
} from "react-bootstrap"

import { PencilSquare } from "react-bootstrap-icons"

const EMETLPersonnelModal = ({ person, ranks, personnelVM }) => {
    const {
        Name,
        Rank,
        ID,
        Email,
    } = person

    const [selectedPerson, setSelectedPerson] = useState(person)

    return (
        <div>
            <p>Rank: {Rank}</p>
            <p>ID: {ID}</p>
            <Dropdown>
                <Dropdown.Toggle
                    variant="secondary"
                    id="dropdown-basic"
                >
                    <PencilSquare />
                    &nbsp;{selectedPerson?.Rank || ""}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    { ranks.map((rank) => {
                        return (
                            <DropdownItem
                                key={rank.ID}
                                onClick={async () => {
                                    const res = await personnelVM.updateRank(person, rank.ID)
                                    if (res) {
                                        setSelectedPerson({
                                            ...person,
                                            Rank: rank.ID,
                                        })
                                    } else {
                                        console.error("Failed to update rank")
                                    }
                                    
                                }}
                            >
                                {rank.ID}
                            </DropdownItem>
                        )
                    })}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    )
}

export default EMETLPersonnelModal